import React from 'react'
import { Progress } from 'reactstrap';
import './strategic-progress.css'

const StrategicProgress = props => {
    return (
        <div className='strategic-progress-container'>

            {props.data.map((d, i) => {
                return (

                    <div key={i} className='strategic-progress'>

                        <div style={{ width: '30%' }} className="strategic-progress-label-case">
                            <p className="strategic-progress-label">{d.label}</p>

                        </div>
                        <div style={{ width: '70%' }}>
                            <Progress striped color={d.type} value={d.value} animated/>

                        </div>

                    </div>
                )
            })}



        </div>
    )

}

export default StrategicProgress